import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import QuantitiesPanel from "@/components/QuantitiesPanel";
import DailyReportsPanel from "@/components/DailyReportsPanel";
import PageHelp from "@/components/PageHelp";

export default function ProjectTool({ tool }) {
  const [params, setParams] = useSearchParams();
  const [projects, setProjects] = useState([]);
  const pid = params.get("project") || "";
  useEffect(() => {
    api.get("/projects").then((r) => { setProjects(r.data); if (!pid && r.data[0]) setParams({ project: r.data[0].id }, { replace: true }); });
  }, [pid, setParams]);
  return (
    <div className="space-y-5" data-testid={`${tool}-page`}>
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div className="flex items-center gap-2">
          <h1 className="text-3xl font-head font-extrabold tracking-tight text-slate-900">{tool === "quantities" ? "Mengenberichte" : "Prüftagesberichte"}</h1>
          <PageHelp id={tool} title={tool === "quantities" ? "Mengenberichte" : "Prüftagesberichte"} text={tool === "quantities" ? "Erfassen Sie Mengen je Projekt strukturiert und nachvollziehbar für Ihre Dokumentation und Abrechnung." : "Legen Sie Tagesberichte mit Wetter, Besetzung und ausgeführten Arbeiten an. „Automatisch“ füllt Vorschläge für Sie aus."} />
        </div>
        <div className="w-72"><Label className="text-xs">Projekt</Label>
          <Select value={pid} onValueChange={(v) => setParams({ project: v })}><SelectTrigger data-testid="tool-project-select"><SelectValue placeholder="Projekt wählen" /></SelectTrigger>
            <SelectContent>{projects.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}</SelectContent></Select></div>
      </div>
      {!pid ? <Card className="p-8 text-center text-slate-400">Bitte ein Projekt wählen.</Card>
        : tool === "quantities" ? <QuantitiesPanel key={pid} projectId={pid} /> : <DailyReportsPanel key={pid} projectId={pid} />}
    </div>
  );
}
